import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';

export const ErrorComponent = ({ name, className, id }) => (
    <ErrorMessage
        id={id || name}
        component="div"
        name={name}
        className={`${className} text-danger`}
        role="alert"
        aria-atomic="true"
    />
);

ErrorComponent.propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
};

ErrorComponent.defaultProps = {
    className: null,
    id: null,
};
